
import React from 'react'

const IconPodium = (props) => (
  <svg {...props} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g fill='none' stroke={props.fill} strokeWidth='1.5'>
      <rect x='1.5' y='14' width='7' height='7' />
      <rect x='8.5' y='9' width='7' height='12' />
      <rect x='15.5' y='16' width='7' height='5' />
    </g>
  </svg>
)

IconPodium.defaultProps = {
  fill: 'white',
  width: 24,
  height: 24
}

export default IconPodium



// WEBPACK FOOTER //
// ./src/icons/IconPodium.js